import { createAsyncThunk } from "@reduxjs/toolkit";
import { ICommonProduct, IProduct } from "../products/products.interface";
import {
  addCustomOrderService,
  deleteCustomOrderService,
  updateCustomOrderService,
} from "./customOrder.service";
import { IWholesaleOrder } from "../wholesale/wholesale.interface";
import { getWholesaleOrderByIDService } from "../wholesale/wholesale.service";

export const getCustomerOrder = createAsyncThunk<
  IWholesaleOrder,
  string,
  { rejectValue: any }
>("customerOrder/getCustomerOrder", async (id: string, { rejectWithValue }) => {
  try {
    const data = await getWholesaleOrderByIDService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const addCustomOrder = createAsyncThunk<
  IProduct,
  ICommonProduct,
  { rejectValue: any }
>("customerOrder/addCustomOrder", async (payload, { rejectWithValue }) => {
  try {
    const data = await addCustomOrderService(payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const deleteCustomOrder = createAsyncThunk<
  IProduct,
  string,
  { rejectValue: any }
>("customerOrder/deleteCustomOrder", async (id, { rejectWithValue }) => {
  try {
    const data = await deleteCustomOrderService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const updateCustomOrder = createAsyncThunk<
  IProduct,
  { id: string; payload: ICommonProduct },
  { rejectValue: any }
>(
  "customerOrder/updateCustomOrder",
  async (
    {
      id,
      payload,
    }: {
      id: string;
      payload: ICommonProduct;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await updateCustomOrderService(id, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);
